import { Injectable } from '@angular/core';

@Injectable()
export class LiteStaticViewDataServiceService {

  constructor() { }
  public static Left_Menu_View = {
    'view_id': 'left_menu',
    'name': 'Left Menu',
    'apiEndPoints': [],
    'buttons': [
      {
        'name': 'Dashboard',
        'router_link': './workspace',
        'class': 'dashboard',
        'alternateClass': 'icon-dashboard-active',
        'active': 1,
        'enable':true
      }/*,
      {
        'name': 'All Elements',
        'router_link': './elements',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'active': 1,
        'enable':true
      },
      {
        'name': 'Pages',
        'router_link': './pages',
        'class': 'pages',
        'alternateClass': 'icon-pages',
        'active': 1,
        'enable':true
      },
      {
        'name': 'Feeds',
        'router_link': './wire',
        'class': 'feeds',
        'alternateClass': 'icon-feeds',
        'active': 1,
        'enable':true
      },
      {
        'name': 'Translated Feeds',
        'router_link': './translated-wire',
        'class': 'translatedFeeds',
        'alternateClass': 'icon-feeds',
        'active': 1,
        'enable':false
      },
      {
        'name': 'Videos',
        'router_link': './videos',
        'class': 'videos',
        'alternateClass': 'icon-video',
        'active': 1,
        'enable':true
      },
      {
        'name': 'Images',
        'router_link': './images',
        'class': 'images',
        'alternateClass': 'icon-image-library',
        'active': 1,
        'enable':true
      }
      ,{
        'name': 'Users',
        'router_link': './users',
        'class': 'users',
        'alternateClass': 'icon-user-management',
        'active': 1,
        'enable':true
      },
      {
        'name': 'Reports',
        'router_link': './reports',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'enable':false
      }*/
    ]
  };
  public static Story_listing_View = {
    'view_id': 'all_stories',
    'list_router': 'lite/dash/story',
    'name': 'All Stories',
    'socketCodes': [1, 2, 7],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/dashboard/meta',
      suggestion: '/api/cms/story/suggestions',
      unlock: '/api/cms/unlock/article'
    },
    fields: '&fields=reusable,metadata.markUnimportant,metadata.notificationSent,quickReadStatus,metadata.killed,metadata.tags,metadata.breakingNews,metadata.plagiarismChecked,metadata.plagiarisedContent,metadata.sponsored,lockedByUserId,id,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,title,type,metadata.section,metadata.authors,lastModifiedDate,lastModifiedByUserName,metadata.authorsList,readByUsers,mobileHeadline,metadata.ampStatus,summaryStatus',
    sortBy: 'lastModifiedDate',
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'title',
        'class': 'headline spImg',
        'type': 'text',
        'conditionOn': 1
      },
      {
        'header_id': 'format',
        'name': 'Type',
        'model_id': 'type',
        'class': 'format',
        'type': 'text',
        'showIcon': true

      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'metadata.status',
        'class': 'status',
        'type': 'status',
        'colorCondition': true
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'metadata.section',
        'class': 'format',
        'type': 'text'
      },
      {
        'header_id': 'byline',
        'name': 'Byline',
        'model_id': 'metadata.authors[0]',
        'class': 'author',
        'type': 'text'
      },
      {
        'header_id': 'lastupdae',
        'name': 'Last Updated On',
        'model_id': 'lastModifiedDate',
        'class': 'lastupdae',
        'type': 'date',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate'
      },
      {
        'header_id': 'lastModifiedBy',
        'name': 'Updated By',
        'model_id': 'lastModifiedByUserName',
        'class': 'lastModifiedBy',
        'type': 'text'
      }
    ],
    'filters': [
      {
        "filter_id": "domain",
        "name": "Domain",
        "facet_name_meta": "flags",
        "facet_name": "domainId",
        "type": "domainList"

      },
      {
        'filter_id': 'byline',
        'name': 'Byline',
        'facet_name_meta': 'authorNames',
        'facet_name': 'metadata.authors',
        'type': 'api_filter'
      },
      {
        'filter_id': 'createdon',
        'name': 'Created On',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'format',
        'name': 'Type',
        'facet_name_meta': 'types',
        'facet_name': 'type',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'statuses',
        'facet_name': 'metadata.status',
        'type': 'checkbox'
      },
      {
        'filter_id': 'social',
        'name': 'Social',
        'facet_name_meta': 'social',
        'facet_name': 'social',
        'type': 'social',
        'social': 'social'

        // 'filter_id': 'updated',
        // 'name': 'Updated',
        // 'facet_name_meta': 'lastModifiedDate',
        // 'facet_name': 'lastModifiedDate',
        // 'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'metadata.section',
        'type': 'checkbox'
      },

      {
        'filter_id': 'lastModifiedByUserName',
        'name': 'Created by',
        'facet_name_meta': 'createdBy',
        'facet_name': 'createdBy',
        'type': 'api_filter'
      },
      {
        'filter_id': 'agency',
        'name': 'Agency',
        'facet_name_meta': 'agencies',
        'facet_name': 'metadata.agency',
        'type': 'checkbox'
      },
      {
        'filter_id': 'flags',
        'name': 'Category',
        'facet_name_meta': 'flags',
        'facet_name': 'metadata',
        'type': 'radio',
        'social': 'social'
      }
    ]
  };


}
